import type { FC } from "react";
import { Route, Routes } from "react-router-dom";

import StaffRegulators from "./StaffRegulators";
import NewStaffRegulator from "./NewStaffRegulator/NewStaffRegulator";
import StaffRegulatorProfile from "./StaffRegulatorProfile/StaffRegulatorProfile";

const StaffRegulatorsApp: FC = () => (
  <Routes>
    <Route index element={<StaffRegulators />} />
    <Route path="new" element={<NewStaffRegulator />} />
    <Route path=":regulatorId" element={<StaffRegulatorProfile />} />
  </Routes>
);

export default StaffRegulatorsApp;
